import React from 'react';

const StudentResources = [
  {
    title: 'Health & Wellness',
    phone: '416-978-8030',
    hours: 'Business Hours',
    location: '700 Bay Street, 3rd, 12th, and 14th floors',
    website: 'https://studentlife.utoronto.ca/department/health-wellness/',
    description:
      'Range of health services for physical and mental health, wellness programs, and information.'
  },
  {
    title: 'Health & Wellness Mental Health Services',
    phone: '416-978-8030, option 5',
    hours: 'Business Hours',
    location: '700 Bay Street, 12th Floor',
    website: 'https://studentlife.utoronto.ca/service/mental-health-clinical-services/',
    description:
        <p>
		Range of mental health clinical services to suit student needs. 
        </p>
  },
  {
    title: 'Health & Wellness Peer Support Service',
    phone: '',
    hours: '',
    location: '',
    website: 'https://studentlife.utoronto.ca/service/peer-support/',
    description:
      'Chat with trained UofT peers in 1:1, drop-in, confidential spaces online or in-person.'
  },
  {
    title: 'Centre for Learning Strategy Support',
    phone: '',
    hours: 'Business Hours',
    location: '800 Bay Street, 5th Floor',
    website: 'https://learningstrategy.utoronto.ca/',
    description:
      'Help with identifying and achieving learning goals along with access to tailored learning supports.'
  },
  {
    title: 'Accessibility Services',
    phone: '416-978-8060',
    hours: 'Business Hours',
    location: '455 Spadina Ave., 4th Floor, Suite 400',
    website: 'https://studentlife.utoronto.ca/department/accessibility-services/',
    description:
      'Provides services and support for learning, problem solving and inclusion and assistance with navigating disability-related barriers to academic success.'
  },
  {
    title: 'Anti-Racism & Cultural Diversity Office',
    phone: '416-978-1259',
    hours: 'Business Hours',
    location: '155 College Street, Suite 356',
    website: 'www.antiracism.utoronto.ca',
    description:
        'Provides support to students, staff and faculty through education programming, complaint resolution support, strategic initiatives and community outreach and engagement.'
  },
  {
    title: 'Campus Safety',
    phone: ['416-978-2222 (Urgent)', '416-978-2323 (Non-urgent)'],
    hours: '24/7',
    location: '21 Sussex Ave',
    website: 'https://www.campussafety.utoronto.ca/',
    description:
        'Creating safe, secure and equitable environment for students, staff ,faculty and visitors.'
  },
  {
    title: 'Centre for International Experience',
    phone: '416-978-2564',
    hours: 'Business Hours',
    location: 'Cumberland House, 33 St. George Street',
    website: 'https://internationalexperience.utoronto.ca/',
    description:
      'Range of programs and services to support international students, as well as global learning opportunities for all students.'
  },
  {
    title: 'Community Safety Office',
    phone: '416-978-1485',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, 2nd Floor',
    website: 'www.communitysafety.utoronto.ca',
    description:
      'Equity office and tri-campus service that offers short-term support and assistance to students, staff, and faculty members of the University of Toronto community ' +
      'who have experienced personal safety concerns.'
  },
  {
    title: 'Family Care Office',
    phone: '416-978-0951',
    hours: 'Business Hours',
    location: '215 Huron Street, Suite 603',
    website: 'https://familycare.utoronto.ca/',
    description:
      'Provides confidential guidance, resources, referrals, educational programming and advocacy for the University of Toronto students, staff, faculty, post-doctoral fellows and their families.'
  },
  {
    title: 'First Nations House Indigenous Student Services',
    phone: '416-978-8227',
    hours: 'Business Hours',
    location: 'Borden Building North, 563 Spadina Avenue, 3rd Floor',
    website: 'https://studentlife.utoronto.ca/department/first-nations-house/',
    description:
      'Provides culturally relevant services to Indigenous students in support of academic success, personal growth and leadership development.'
  },
  {
    title: 'Housing',
    phone: '416-978-8045',
    hours: 'Business Hours',
    location: '214 College St., Room 150',
    website: 'www.studentlife.utoronto.ca/hs',
    description:
      'Housing Services offers the information, resources and support you need to meet your housing goals.'
  },
  {
    title: 'Multi-Faith Centre',
    phone: '416-946-3120',
    hours: 'Business Hours',
    location: '569 Spadina Avenue',
    website: 'https://studentlife.utoronto.ca/department/multi-faith-centre-for-spiritual-study-practice/',
    description:
      'Supports the spiritual well-being of students, staff and faculty and increases understanding of and respect for religious beliefs and practices.'
  },
  {
    title: 'Sexual & Gender Diversity Office',
    phone: '416-946-5624',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, Suites 416-417',
    website: 'sgdo.utoronto.ca',
    description:
      'Tri-campus service that provides innovative education, programming, resources and advocacy on sexual and gender diversity for students, faculty, librarians, and staff.'
  },
  {
    title: 'Sexual Violence Prevention & Support Centre',
    phone: '416-978-2266',
    hours: 'Business Hours',
    location: 'Gerstein Science Information Centre (Gerstein Library), Suite B139',
    website: 'https://www.svpscentre.utoronto.ca/',
    description:
        'Serves students, staff, and faculty at the University of Toronto who are affected by sexual violence or harassment.'
  },
  {
    title: 'TravelSafer',
    phone: '416-978-7233',
    hours: '24/7',
    location: '',
    website: 'https://www.campussafety.utoronto.ca/travel-safer',
    description:
        'Free service offered by the University of Toronto Campus Safety that is available 24/7 365 days a year. A Building Patroller or Special Constable will escort you to and from any location on campus and abutting TTC stations for added peace of mind.'
  },
  {
    title: 'U of T Telus Health Student Support',
    phoneNode: (
      <span>
        <a href="tel:1-844-451-9700">1-844-451-9700</a>
        <br />
        Outside of North America: <br /><a href="tel:001-416-380-6578">001-416-380-6578</a>
        <br />
      </span>
    ),
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'https://uoft.me/THSS',
    description:
      'Real-time and/or appointment-based, multi-lingual, confidential, 24-hour support for any school, health, or general life concern at no cost to students.'
  },
];

const StudentResourcesUTSC = [
  {
    title: 'NAVI',
    phone: '',
    hours: '',
    location: '',
    website: 'https://prod.virtualagent.utoronto.ca/',
    description:
          'Chat-based virtual assistant for students wanting to learn more about the mental health supports available to them at the University of Toronto. All you have to do is click on the chat button and tell Navi what you need help with or how you are feeling.'
  },
  {
    title: 'Health & Wellness Centre',
    phone: '416 287 7065',
    hours: 'Business Hours',
    location: 'SL-270, 1265 Military Trail',
    website: 'www.utsc.utoronto.ca/hwc',
    description:
      'Offers convenient and confidential health care, counselling and health promotion services for all registered students at UTSC.'
  },
  {
    title: 'AccessAbility Services',
    phone: '416 287 7560',
    hours: 'Business Hours',
    location: 'Arts & Administration Building, AA142, 1265 Military Trail',
    website: 'www.utsc.utoronto.ca/ability',
    description:
      'Provides services and academic accommodations to students who have a documented learning, physical, sensory, mental health disability or medical condition.'
  },
  {
    title: 'Academic Advising & Career Centre',
    phone: '416 287 7561',
    hours: 'Business Hours',
    location: 'AC-213, 1265 Military Trail',
    website: 'www.utsc.utoronto.ca/aacc',
    description:
      'The Centre integrates developmental advising, learning skills, career counselling and employment coaching through individual appointments, workshops, experiential programming, events and a range of online resources.'
  },
  {
    title: 'Sexual & Gender Diversity Office',
    phone: '416 946 5624',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, Suites 416-417',
    website: 'sgdo.utoronto.ca',
    description:
      'Develops partnerships to build supportive learning and working communities at the University ' +
      'of Toronto by working towards equity and challenging discrimination.'
  },
  {
    title: 'Anti-Racism & Cultural Diversity Office',
    phone: '416 978 1259',
    hours: 'Business Hours',
    location: '155 College Street, Suite 356',
    website: 'www.antiracism.utoronto.ca',
    description:
      'Provides assistance and managing confidential concerns and complaints of discrimination and/or harassment based ' +
      'on race, ancestry, place of origin, colour, ethnic origin, citizenship and/or creed.'
  },
  {
    title: 'Sexual Violence Prevention & Support Centre',
    phone: '416 978 2266',
    hours: 'Business Hours',
    location: 'Gerstein Science Information Centre (Gerstein Library), Suite B139 ',
    website: 'www.thesvpcentre.utoronto.ca',
    description:
      'The Centre facilitates access to support, services and accommodations for students, staff and faculty members who have been affected by sexual violence or sexual harassment.'
  },
  {
    title: 'First Nations House (Indigenous Student Services)',
    phone: ['416 978 8227', '1 800 810 8069'],
    hours: 'Business Hours',
    location: '563 Spadina Avenue, 3rd Floor',
    website: 'https://studentlife.utoronto.ca/department/first-nations-house/',
    description:
      'First Nations House provides culturally relevant services to Indigenous students in support ' +
      'of academic success, personal growth and leadership development.'
  },
  {
    title: 'Indigenous Outreach Program',
    phone: '',
    hours: '',
    location: '',
    website: 'www.utsc.utoronto.ca/studentlife/indigenous-outreach-program',
    description:
      'Provides students a place to connect with the Indigenous Community on traditional teaching land.'
  },
  {
    title: 'Lone Worker',
    phone: '416 287 7398',
    hours: '24/7',
    location: 'Various, UTSC Campus',
    website: 'www.utsc.utoronto.ca/police/lone-worker',
    description:
      'If you are working or studying alone after regular business hours or in isolated areas, Campus Community Police will provide you with a personal safety radio for direct contact should a personal safety emergency arise.'
  },
  {
    title: 'Student Life',
    phone: '416 208 4760',
    hours: 'Business Hours',
    location: 'SL-157, 1265 Military Trail',
    website: 'www.utsc.utoronto.ca/studentlife',
    description:
      'Offers exciting programs, cultivates strong communities and provides opportunities that enhance the student experience outside of the classroom.'
  },
  {
    title: 'Community Safety Office',
    phone: '416 978 1485',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, 2nd Floor',
    website: 'www.communitysafety.utoronto.ca',
    description:
      'Responds to students, staff, and faculty members of the University of Toronto community ' +
      'who have personal safety concerns.'
  },
  {
    title: 'International Student Centre',
    phone: '416 287 7087',
    hours: 'Business Hours',
    location: 'Highland Hall, HL448',
    website: 'www.uoft.me/utscinternational',
    description:
      'Provides International students with support and guidance including the University Health Insurance Plan.'
  },
  {
    title: 'Multi-Faith Engagement',
    phone: 'cep@utsc.utoronto.ca',
    hours: 'Business Hours',
    location: '',
    website: 'www.utsc.utoronto.ca/studentlife/multi-faith-engagement',
    description:
      'Services and programs to foster practice, observance, interfaith community, support and learning to students.'
  },
  {
    title: 'Student Housing and Residence Life',
    phone: '416 287 7365',
    hours: 'Business Hours',
    location: 'Residence Centre, 1265 Military Trail',
    website: 'www.utsc.utoronto.ca/residences',
    description:
      'Fosters a safe, fun, and inclusive community that supports your academic achievement and personal development.'
  },
  {
    title: 'Travel Safer',
    phone: '416 287 7022',
    hours: '24/7',
    location: 'Various, UTSC Campus',
    website: 'utsc.utoronto.ca/police/travel-safer',
    description:
      'If you feel uncertain when you need to travel to your vehicle, residence, or another building, and would feel more comfortable having someone travel with you.'
  },
  {
    title: 'UofT Telus Health Student Support',
    phone: '1-844-451-9700',
    hours: '24/7',
    location: 'Canada and International',
    website: 'https://uoft.me/THSS',
    description:
        'Real-time and/or appointment-based, multi-lingual, confidential, 24-hour support for any school, health, or general life concern at no cost to students.'
  },
  {
    title: 'Campus Safety',
    phone: '416-978-2222',
    hours: 'Business Hours',
    location: 'Science Wing, Room SW 304, 1265 Military Trail',
    website: 'https://www.utsc.utoronto.ca/safety/',
    description:
      'Provides programs on personal safety, protection of property, conflict resolution, maintenance of public order, community services and referral, crime prevention and detection.'
  }
];

const StudentResourcesUTM = [
  {
    title: 'NAVI',
    phone: '',
    hours: '',
    location: '',
    website: 'https://prod.virtualagent.utoronto.ca/',
    description:
          'Chat-based virtual assistant for students wanting to learn more about the mental health supports available to them at the University of Toronto. All you have to do is click on the chat button and tell Navi what you need help with or how you are feeling.'
  },
  {
    title: 'Health & Counselling Centre',
    phone: '905 828 5255',
    hours: 'Business Hours',
    location: 'DV 1152',
    website: 'www.utm.utoronto.ca/health',
    description:
      'HCC provides medical services, physical and mental health services and peer to peer health education through an interdisciplinary team of health professionals. The HCC also has a dedicated student wellness space, the Wellness Den, that features daily, drop-in wellness activities to support learning and success. Drop by the Student Services Hub (DV 2207) to build your wellness routine'
  },
  {
    title: 'Accessibility Services',
    phone: '905 569 4699',
    hours: 'Business Hours',
    location: 'Student Services Hub, Davis Building',
    website: 'www.utm.utoronto.ca/accessibility',
    description:
      'Provides academic accommodations and services to students who have a disability, mental health condition, acquired brain injury, ADHD, autism spectrum disorder or chronic health condition. Students who have temporary disabilities are also eligible to receive services.'
  },
  {
    title: 'Robert Gillespie Academic Skills Centre',
    phone: '905 828 3858',
    hours: 'Business Hours',
    location: 'MN3251',
    website: 'www.utm.utoronto.ca/asc',
    description:
      'Offers a range of workshops, seminars, facilitated study groups, and individual consultations to help identify and develop academic skills needed for success in your studies.'
  },
  {
    title: 'Sexual & Gender Diversity Office',
    phone: '416 946 5624',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, 4th Floor',
    website: 'https://sgdo.utoronto.ca/',
    description:
      'Develops partnerships to build supportive learning and working communities at the University ' +
      'of Toronto by working towards equity and challenging discrimination.'
  },
  {
    title: 'Anti-Racism & Cultural Diversity Office',
    phone: '416 978 1259',
    hours: 'Business Hours',
    location: '155 College Street, Suite 356',
    website: 'www.antiracism.utoronto.ca',
    description:
      'Provides assistance and managing confidential concerns and complaints of discrimination and/or harassment based ' +
      'on race, ancestry, place of origin, colour, ethnic origin, citizenship and/or creed.'
  },
  {
    title: 'Sexual Violence Prevention & Support Centre',
    phone: '416 978 2266',
    hours: 'Business Hours',
    location: 'DV 3094G and DV 3093F',
    website: 'www.svpcentre.utoronto.ca',
    description:
      'Provide confidential services for students, staff, and faculty affected by sexual violence and/or sexual harassment and also provides programming, training, education and consultation.'
  },
  {
    title: 'Good2Talk Student Helpline',
    phone: '1 866 925 5454',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'good2talk.ca',
    description:
      'Professional counselling, information and referrals helpline for mental health, addictions and students ' +
      'well-being.'
  },
  {
    title: 'Indigenous Centre',
    phone: '905 569 4867',
    hours: 'Business Hours',
    location: 'MN 6104, 6106, 6108, 6010',
    website: 'www.utm.utoronto.ca/indigenous-centre',
    description:
      'The UTM Indigenous Centre works to support Indigenous students, staff, faculty, and librarians through community-building, ceremony, programming, and service delivery. The Indigenous Centre also extends support to non-Indigenous peoples to better understand Indigenous peoples and their ways of being.'
  },
  {
    title: 'Community Safety Office',
    phone: '416 978 1485',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, 2nd Floor',
    website: 'www.communitysafety.utoronto.ca',
    description:
      'Equity office and tri-campus service that offers short-term support and assistance to students, staff, and faculty members of the University of Toronto community who have experienced personal safety concerns.'
  },
  {
    title: 'International Education Centre',
    phone: '905 569 4716',
    hours: 'Business Hours',
    location: 'DV2091A',
    website: 'www.utm.utoronto.ca/international',
    description: 'IEC offers international opportunities for academic credit and as co-curricular experiences. IEC also assists international students on immigration-related matters, UHIP and transition to University while offering programs to connect.'
  },
  {
    title: 'Multi-Faith Centre',
    phone: '',
    hours: '',
    location: '',
    website: 'www.utm.utoronto.ca/utm-engage/student-groups/multi-faith',
    description:
      'Provides opportunities to celebrate your spiritual and faith-based practices on campus by providing multi-faith spaces on campus and faith-based campus groups.'
  },
  {
    title: 'Student Housing & Residence Life',
    phone: '905 828 5286',
    hours: 'Business Hours',
    location: 'Oscar Peterson Hall (OPH), Room 120',
    website: '',
    description:
      <div>Live Chat: <a href="www.utm.utoronto.ca/housing" target="_blank">www.utm.utoronto.ca/housing</a><br/><a href="mailto:resdesk.utm@utoronto.ca">resdesk.utm@utoronto.ca</a><br/>Student Housing provides a diverse range of housing options, helps students with off-campus services and offers information and resources.</div>
  },
  {
    title: 'WalkSafer Program',
    phone: '905 828 5200',
    hours: '24/7',
    location: '',
    website:
      'https://www.utm.utoronto.ca/campus-police/safety-programs/work-alone-walksafe-programs',
    description:
      'WalkSafer escorts will come to your location to walk you to your destination, including waiting with you at a bus stop.'
  },
  {
    title: 'Campus Safety',
    phone: '',
    phoneNode: (
      <span>
        <a href="tel:905 828 5200">905-828-5200</a> (general inquiries)
        <br />
        <a href="tel:905 569 4333">905-569-4333</a> (emergencies)
        <br />
      </span>
    ),
    hours: '24/7',
    location: 'DV 3116',
    website: 'www.utm.utoronto.ca/safety',
    description:
      'Dedicated to creating and maintaining a safe and secure environment for students, staff, faculty and visitors.'
  },
  {
    title: 'U of T Telus Health Student Support',
    phoneNode: (
      <span>
        <a href="tel:1-844-451-9700">1-844-451-9700</a>
        <br />
        Outside of North America: <br /><a href="tel:001-416-380-6578">001-416-380-6578</a>
        <br />
      </span>
    ),
    hours: '24/7',
    location: 'Canada and International',
    website: 'https://uoft.me/THSS',
    description:
      'Real-time and/or appointment-based, multi-lingual, confidential, 24-hour support for any school, health, or general life concern at no cost to students.'
  },
  {
    title: 'UTM Positive Space Committee',
    phone: '',
    hours: '',
    location: '',
    website:
      '',
    description:
	<div>Welcomes participation from 2SLGBTQ+ students, staff and faculty and allies to create more inclusive spaces for 2SLGBTQ+ members of the University community. Join the committee and listserv – more information at: <a href="https://positivespace.utoronto.ca/mississauga" target="_blank">positivespace.utoronto.ca/mississauga</a></div>
  }
];

const StaffResources = [
  {
    title: 'Employee & Family Assistance Program',
    phone: '1-855-597-2110',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'https://people.utoronto.ca/employees/efap/',
    description:
      'Offers confidential short–term counselling, coaching, information, and support for all types of issues relating to mental health, health management, and achieving greater personal and workplace well-being for employees of the University of Toronto and their dependents.'
  },
  {
    title: 'Employee Health & Well-being Programs & Services',
    phone: '416-946-0537',
    hours: 'Business Hours',
    location: '263 McCaul Street, 2nd Floor',
    website: 'https://people.utoronto.ca/culture/wellness/',
    description:
      'Supports employees and managers involved in sick leave, long-term disability, occupational health issues, workplace injuries, and workplace accommodation for employees with disabilities.'
  },
  {
    title: 'Student Crisis Response/Student, Progress & Support',
    phone: '416-946-7111',
    hours: 'Business Hours',
    location: 'Various, Campus',
    website: 'https://studentlife.utoronto.ca/service/faculty-support-for-responding-to-distressed-students/',
    description:
      'Resource for staff and faculty responding to a distressed student during an emergency, an immediate crisis, a personal safety situation or where the student is presenting concerning behaviour.'
  },
  {
    title: 'U of T Telus Health Student Support Consultations',
    phone: '',
    hours: '',
    location: '',
    website: 'https://www.utm.utoronto.ca/sas/myssp-consultative-support-after-hours',
    description:
    <div>
	<p>The Telus Health Student Support service provides direct support to faculty and staff who work with students. </p>
	<li>
		To access consultative support, call <a href="tel:+1-844-451-9700">1.844.451.9700</a> anytime 
	</li>
	<li>
		Identify yourself as a staff or faculty from your institution and request consultative support.
	</li>
	<li>
      		Please remember that in the case of Campus Safety Services and U of T Telus Health Student Support, follow up will occur the next business day (or in the event of more serious issues immediately) with the Dean of Student Affairs. We may be in contact with you directly for more information.
	</li>
    </div>
  }
];

const StaffResourcesUTSC = [
  {
    title: 'Employee & Family Assistance Program',
    phone: '1-855-597-2110',
    hours: '24/7',
    location: '',
    website: 'https://people.utoronto.ca/employees/efap/',
    description:
      'Offers confidential short–term counselling, coaching, information, and support for all types of issues relating to mental health, health management, and achieving greater personal and workplace well-being for employees of the University of Toronto and their dependents.'
  },
  {
    title: 'Employee Health & Well-being Programs & Services',
    phone: '416-946-0537',
    hours: 'Business Hours',
    location: '263 McCaul Streeti, 2nd Floor',
    website: 'https://people.utoronto.ca/culture/wellness/ ',
    description:
      'Supports employees and managers involved in sick leave, long-term disability, occupational health issues, workplace injuries, and workplace accommodation for employees with disabilities.'
  },
  {
    title: 'Student Crisis Response/Student, Progress & Support ',
    phone: '416 946 7111',
    hours: 'Business Hours',
    location: 'Various, Campus',
    website: 'https://studentlife.utoronto.ca/service/faculty-support-for-responding-to-distressed-students/',
    description:
      'Resource for staff and faculty responding to a distressed student during an emergency, an immediate crisis, a personal safety situation or where the student is presenting concerning behaviour.'
  },
  {
    title: 'UofT Telus Health Student Support Consultations',
    phone: '',
    hours: '',
    location: '',
    description:
    <div>
	<p>The Telus Health Student Support service provides direct support to faculty and staff who work with students. </p>
	<li>
		To access consultative support, call <a href="tel:+1-844-451-9700">1.844.451.9700</a> anytime 
	</li>
	<li>
		Identify yourself as a staff or faculty from your institution and request consultative support.
	</li>
	<li>
      		Please remember that in the case of Campus Safety Services and U of T Telus Health Student Support, follow up will occur the next business day (or in the event of more serious issues immediately) with the Dean of Student Affairs. We may be in contact with you directly for more information.
	</li>
    </div>
  }
];

const StaffResourcesUTM = [
  {
    title: 'Employee & Family Assistance Program',
    phone: '1-855-597-2110',
    hours: '24/7',
    location: '',
    website: 'https://people.utoronto.ca/employees/efap/',
    description:
      'Offers confidential short–term counselling, coaching, information, and support for all types of issues relating to mental health, health management, and achieving greater personal and workplace well-being for employees of the University of Toronto and their dependents.'
  },
  {
    title: 'Employee Health & Well-being Programs & Services',
    phone: '416-946-0537',
    hours: 'Business Hours',
    location: '263 McCaul Street, 2nd Floor',
    website: 'https://people.utoronto.ca/culture/wellness/',
    description:
      'Supports employees and managers involved in sick leave, long-term disability, occupational health issues, workplace injuries, and workplace accommodation for employees with disabilities.'
  },
  {
    title: 'Student Crisis Response/Student - Progress & Support ',
    phone: '416 946 7111',
    hours: 'Business Hours',
    location: 'Various, Campus',
    website: 'https://utm-utoronto-advocate.symplicity.com/care_report/index.php/pid169350?',
    description:
      'Resource for staff and faculty responding to a distressed student during an emergency, an immediate crisis, a personal safety situation or where the student is presenting concerning behaviour.'
  },
  {
    title: 'U of T Telus Health Student Support Consultations',
    phone: '',
    hours: '',
    location: '',
    website: 'https://www.utm.utoronto.ca/sas/myssp-consultative-support-after-hours',
    description:
    <div>
	<p>The Telus Health Student Support service provides direct support to faculty and staff who work with students. </p>
	<li>
		To access consultative support, call <a href="tel:+1-844-451-9700">1.844.451.9700</a> anytime 
	</li>
	<li>
		Identify yourself as a staff or faculty from your institution and request consultative support.
	</li>
	<li>
      		Please remember that in the case of Campus Safety Services and U of T Telus Health Student Support, follow up will occur the next business day (or in the event of more serious issues immediately) with the Dean of Student Affairs. We may be in contact with you directly for more information.
	</li>
    </div>
  }
];

const CommunityResources = [
  {
    title: 'Anishnawbe Health Toronto Mental Health Services',
    phone: '416-920-2605',
    hours: 'Business Hours',
    location: '179 Gerrard St E; Other Toronto Locations',
    website: 'www.aht.ca',
    description:
        'Multi-disciplinary approach to care including counselling services with the option of traditional counsellors or mental health counsellors, as well as psychiatry, psychology and case management.'
  },
  {
    title: "Assaulted Women's Helpline",
    phone: '1-866-863-0511',
    hours: '24/7',
    location: '',
    website: 'www.awhl.org/home',
    description:
        'Free, anonymous and confidential 24-hour telephone and TTY crisis telephone line to all women in the province of Ontario who have experienced any form of abuse. Provides crisis counselling, safety planning, emotional support, information, and referrals.'
  },
  {
    title: 'Connex Ontario',
    phone: '1-866-531-2600',
    hours: '24/7',
    location: '',
    website: 'www.connexontario.ca/',
    description:
      'Provides confidential and free information about health services information for people experiencing problems with alcohol and drugs, mental illness and/or gambling.'
  },
  {
    title: 'Distress Centres of Greater Toronto',
    phone: '416-408-4357',
    hours: '24/7',
    location: '',
    website: 'www.torontodistresscentre.com',
    description:
      'Provides crisis, emotional support and suicide prevention + intervention + postvention services to individuals in our community via hotline, online chat, and text and some in-person individual and group support.'
  },
  {
    title: 'Gerstein Crisis Centre',
    phone: '416-929-5200',
    hours: '24/7',
    location: '100 Charles Street East; 1045 Bloor Street West',
    website: 'gersteincentre.org',
    description:
        'Provides crisis intervention, wellness and recovery activities, and training and education including 24/7 telephone support, in-person mobile crisis team, community support referrals, substance use crisis management, and follow-up.'
  },
  {
    title: 'Good2Talk Ontario',
    phone: '1-866-925-5454',
    hours: '24/7',
    location: '',
    website: 'good2talk.ca',
    description:
        'Ontario post-secondary students can receive professional counselling, volunteer crisis support and information, and referrals about mental health services and supports on and off campus.'
  },
  {
    title: 'LGBT Youth Line',
    phone: 'Text 647-694-4275 or Chat',
    hours: 'Sun – Fri 4PM – 9:30 PM EST',
    location: '',
    website: 'www.youthline.ca',
    description:
        'Confidential, non-judgmental & informed LGBTTQQ2SI peer support that affirms and supports the experiences of youth (29 and under) across Ontario via chat and, text services.'
  },
  {
    title: 'Toronto Rape Crisis Centre/Multicultural Women Against Rape',
    phone: '416-597-8808',
    hours: '24/7',
    location: '',
    website: 'trccmwar.ca',
    description:
        'Provides anti-oppressive, feminist peer support to survivors of gender-based or sexualized violence, public education, activism, and provides direct individual and group support to survivors and their supporters.'
  },
  {
    title: 'Sexual Assault/Domestic Violence Care Centre (SA/DVCC)',
    phone: '416-323-6040',
    hours: '24/7',
    location: '76 Grenville Street, Ground Floor (in the AACU)',
    website:
      'www.womenscollegehospital.ca/programs-and-services/sexual-assault-domestic-violence-care-centre',
    description:
        'Comprehensive service that assists women, men, and trans people, over the age of 14, who are victims/survivors of sexual assault and domestic/intimate partner violence.'
  },
  {
    title: 'Kids Help Phone',
    phone: '1-800-668-6868 or Text 686868',
    hours: '24/7',
    location: '',
    website: 'https://kidshelpphone.ca',
    description:
        'Kids Help Phone is a 24/7 e-mental health service offering free, confidential support to young people in English and French. Phone service is also offered in over 100 languages including Plains Cree, Severn Ojibwe, Ukrainian, Russian, Pashto, Dari, Mandarin and Arabic with the help of trained interpreters.'
  },
  {
    title: 'Naseeha Mental Health',
    phone: '1 (866) 627-3342',
    hours: '12 PM – 3 AM, 7 days a week',
    location: '',
    website: 'https://naseeha.org',
    description:
        'Naseeha Mental Health is confidential helpline, where youth can receive immediate, anonymous, and confidential support over the phone from 12 PM – 3 AM, 7 days a week. With a particular focus on Muslim youth/students.  '
  },
  {
    title: 'Hong Fook Mental Health Association',
    phone: '416-493-4242',
    hours: '',
    location: '407 Huron Street, 3rd Floor',
    website: 'https://hongfook.ca/association/',
    description:
        'Hong Fook provides a continuum of mental health services covering the spectrum from “promoting wellness” to “managing illness” in Cambodian, Chinese (Cantonese and Mandarin), Korean, Vietnamese and English. Services include: Intake, Case Management, Support within Housing, Group Psychotherapy, Ontario Structured Psychotherapy and Ontario Telemedicine Network.'
  },
  {
    title: 'TAIBU Community Health Centre (CHC)',
    phone: '416-644-3536',
    hours: '',
    location: '27 Tapscott Road, Unit 1',
    description:
        <div><a href="mailto:info@taibuchc.ca">info@taibuchc.ca</a><br/>TAIBU CHC is a multidisciplinary, non-for-profit, established to serve the Black Community across the GTA. Social Workers and Therapists use an anti-oppressive framework, combined with Cognitive Behavioural Therapy, Narrative Therapy and the Recovery Model of Care approach.</div>
  },
  {
    title: 'South Asian Canadians Health and Social Services (SACHSS)',
    phone: '',
    phoneNode: (
      <span>
        <a href="tel:+1-437-254-2794">+1-437-254-2794</a>, <a href="tel:+1-647-523-6380">+1-647-523-6380</a> or <a href="tel:+1-416-863-0511">+1-416-863-0511</a>
        <br />
      </span>
    ),
    hours: '24/7',
    location: '27 Tapscott Road, Unit 1',
    website: 'https://sachss.ca/',
    description:
        'SACHSS offers culturally and linguistically appropriate services for South Asian men, women, seniors, and youth, and other communities. SACHSS also offers a distress helpline in multiple languages (English, French, Hindi, Punjabi, Urdu, Tamil, Gujarati, Malayalam, Arabic).'
  }
];

const CommunityResourcesUTSC = [
  {
    title: 'Sexual Assault & Domestic Violence Care Centre',
    phone: '416 495 2555',
    hours: '24/7',
    location: `Scarborough Hospital Network's Emergency Departments`,
    website:
      'www.shn.ca/sexual-assault/',
    description:
      'A comprehensive service that assists female/male/transgendered individuals over 12 years-old, who have been sexually assaulted or experienced intimate partner violence.'
  },
  {
    title: 'Toronto Rape Crisis Centre/Multicultural Women Against Rape ',
    phone: '416 597 8808',
    hours: '24/7',
    website: 'trccmwar.ca',
    description:
      'A grassroots, women and non-binary run collective working towards a violence-free world by providing anti-oppressive, feminist peer support to survivors of sexual violence through support, education and activism.'
  },
  {
    title: 'Anishnawbe Health Toronto Mental Health Crisis Line',
    phone: ['416 360 0486', '416 920 2605'],
    hours: 'Business Hours',
    location: '225 Queen St E or 179 Gerrard, St E',
    website: 'www.aht.ca',
    description:
      'Improves health & well-being with Anishnawbe Health Toronto traditional healers, Elders and medicine people, ' +
      'and other health professionals.'
  },
  {
    title: 'Drug & Alcohol Helpline',
    phone: '1 866 531 2600',
    hours: '24/7',
    website: 'www.connexontario.ca/',
    description:
      'Provides confidential and free information about health services information for people experiencing problems with alcohol and drugs, mental illness and/or gambling.'
  },
  {
    title: "Assaulted Women's Helpline",
    phone: '416 863 0511',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'www.awhl.org/home',
    description:
      'Offers a 24-hour telephone and TTY crisis line to all woman who have experienced abuse.'
  },
  {
    title: 'Distress Centres of Greater Toronto',
    phone: '416 408 4357',
    hours: '24/7',
    website: 'www.torontodistresscentre.com',
    description:
      'Provides crisis, emotional support and suicide prevention + intervention + postvention services via hotline, online chat, and text, and some in-person individual and group support.'
  },
  {
    title: 'LGBT Youth Line',
    phoneNode: (
      <span>
        Text <a href="tel:647-694-4275">647-694-4275</a> or Chat Sun – Fri 4PM – 9:30 PM EST
      </span>
    ),
    hours: '24/7',
    website: 'www.youthline.ca',
    description:
      'Confidential, non-judgmental & informed LGBTTQQ2SI peer support that affirms and supports the experiences of youth (29 and under) across Ontario via chat and text services.'
  },
  {
    title: 'Gerstein Centre Mental Health Crisis Line',
    phone: ['416-929-5200', 'TTY:416-929-9647'],
    hours: '24/7',
    location:
      'Phone: Various, Ontario; Crisis Response Team: South Central Toronto',
    website: 'gersteincentre.org',
    description:
      'Provides mental health crisis support, strategies for addressing immediate problems, and connections to ' +
      'services offering ongoing support.'
  },
  {
    title: 'Scarborough Health Network Community Crisis Program',
    phone: '416 495 2891',
    hours: '24/7',
    location: 'Various, Scarborough & East York',
    website: 'www.shn.ca/mental-health/crisis-support/',
    description:
      'Providing telephone crisis support, crisis de-escalation and support, safety and crisis planning, mental health assessment and referral, brief psychotherapies, and community visits.'
  },
  {
    title: 'Kids Help Phone',
    phone: '1-800-668-6868 or Text 686868',
    hours: '24/7',
    location: '',
    website: 'https://kidshelpphone.ca',
    description:
        'Kids Help Phone is a 24/7 e-mental health service offering free, confidential support to young people in English and French. Phone service is also offered in over 100 languages including Plains Cree, Severn Ojibwe, Ukrainian, Russian, Pashto, Dari, Mandarin and Arabic with the help of trained interpreters.'
  },
  {
    title: 'Naseeha Mental Health',
    phone: '1 (866) 627-3342',
    hours: '12 PM – 3 AM, 7 days a week',
    location: '',
    website: 'https://naseeha.org',
    description:
        'Naseeha Mental Health is confidential helpline, where youth can receive immediate, anonymous, and confidential support over the phone from 12 PM – 3 AM, 7 days a week. With a particular focus on Muslim youth/students.  '
  },
  {
    title: 'South Asian Canadians Health and Social Services (SACHSS)',
    phone: '',
    phoneNode: (
      <span>
        <a href="tel:+1-437-254-2794">+1-437-254-2794</a>, <a href="tel:+1-647-523-6380">+1-647-523-6380</a> or <a href="tel:+1-416-863-0511">+1-416-863-0511</a>
        <br />
      </span>
    ),
    hours: '24/7',
    location: '27 Tapscott Road, Unit 1',
    website: 'https://sachss.ca/',
    description:
        'SACHSS offers culturally and linguistically appropriate services for South Asian men, women, seniors, and youth, and other communities. SACHSS also offers a distress helpline in multiple languages (English, French, Hindi, Punjabi, Urdu, Tamil, Gujarati, Malayalam, Arabic).'
  },
  {
    title: 'TAIBU Community Health Centre (CHC)',
    phone: '416-644-3536',
    hours: '',
    location: '27 Tapscott Road, Unit 1',
    description:
        <div><a href="mailto:info@taibuchc.ca">info@taibuchc.ca</a><br/>TAIBU CHC is a multidisciplinary, non-for-profit, established to serve the Black Community across the GTA. Social Workers and Therapists use an anti-oppressive framework, combined with Cognitive Behavioural Therapy, Narrative Therapy and the Recovery Model of Care approach.</div>
  },
  {
    title: 'Canadian Mental Health Association Toronto (CMHA-Toronto)',
    phone: '(416) 789-7957',
    hours: '',
    website: 'https://cmhato.org/',
    location: '1200 Markham Rd Suite 500, SCARBOROUGH ONTARIO M1H 3C3',
    description:
        <div>At CMHA Toronto, we take a client-first, recovery-oriented approach to supporting people and their families when they experience mental health challenges or live with mental illness. By integrating health and social care, we provide services that aid in long-term wellness.</div>
  },
  {
    title: 'Mood Disorders Association',
    phone: '(888) 486-8236',
    hours: '',
    website: 'https://mooddisorders.ca/',
    location: '36 Eglinton Ave West Suite 602, Toronto ON M4R 1A1',
    description:
        <div>The Mood Disorders Association of Ontario offers free support and recovery programs to people across Ontario living with depression, anxiety or bipolar disorder. We provide drop-in peer support groups, recovery programs, family and youth clinical support, early intervention for mood disorders and psychosis and online tools focused on wellness and recovery.</div>
  }
];

const CommunityResourcesUTM = [
  {
    title: 'Sexual Assault & Domestic Violence Care Centres',
    phone: '905 848 7493',
    hours: '24/7',
    location: 'Trillium Health Centre, 100 Queensway W, Mississauga',
    website: 'https://trilliumhealthpartners.ca/patientservices/womens/Pages/sexualassault.aspx',
    description:
      'Help individuals who have been sexually assaulted or have been victims of domestic violence within the Peel Region (Mississauga, Brampton and Caledon area).'
  },
  {
    title: 'Peel Crisis Services & COAST',
    phone: '905 278 9036',
    hours: '24/7',
    location: '',
    website: 'https://www.ontario.ca/locations/health/locationDetails.php?location=29426534&lang=en',
    description:
      'Offer crisis intervention services (phone and outreach) to people with mental illness who are in crisis.'
  },
  {
    title: 'Distress Centres of Greater Toronto',
    phone: '416 408 4357',
    hours: '24/7',
    location: '',
    website: 'www.torontodistresscentre.com',
    description:
      'Offer anonymous and confidential distress and emotional support lines in 8 languages. Interpreters for callers in crisis are available in 151 languages. TTY service available for the hearing impaired.'
  },
  {
    title: 'Drug & Alcohol Helpline',
    phone: '1 866 531 2600',
    hours: '24/7',
    location: '',
    website: 'https://www.connexontario.ca/',
    description:
      'Provides confidential and free information about health services information for people experiencing problems with alcohol and drugs, mental illness and/or gambling.'
  },
  {
    title: "Assaulted Women's Helpline",
    phone: '416 863 0511',
    hours: '24/7',
    location: '',
    website: 'www.awhl.org/home',
    description:
      'Offers a 24-hour telephone and TTY crisis line to all woman who have experienced abuse.'
  },
  {
    title: 'Distress Centre Halton',
    phone: '905 849 4541',
    hours: '24/7',
    location: '',
    website: '',
    description:
      'Confidential support and referrals provided by volunteers 24 hours a day.'
  },
  {
    title: 'LGBT Youthline',
    phone: '',
    phoneNode: (
      <span>
        Text <a href="tel:647 694 4275">647-694-4275</a> or Chat Sun – Fri 4PM – 9:30 PM EST
      </span>
    ),
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'www.youthline.ca',
    description:
      'Confidential, non-judgmental & informed LGBTTQQ2SI peer support that affirms and supports the experiences of youth (29 and under) across Ontario via chat and text services.'
  },
  {
    title: 'Gerstein Centre Mental Health Crisis Line',
    phone: '416-929-5200; TTY 416-929-9647',
    hours: '24/7',
    location:
      'Phone: Various, Ontario; Crisis Response Team: South Central Toronto',
    website: 'gersteincentre.org',
    description:
      'Provides mental health crisis support, strategies for addressing immediate problems, and connections to ' +
      'services offering ongoing support.'
  },
  {
    title: 'Interim Place',
    phone: '905 676 8515',
    hours: '24/7',
    location: '',
    website: 'http://www.interimplace.com/',
    description:
      'Offers crisis line, online chat, and in-person counselling and support, referrals, information about sexual abuse and assault.'
  },
  {
    title: 'Kids Help Phone',
    phone: '1-800-668-6868 or Text 686868',
    hours: '24/7',
    location: '',
    website: 'https://kidshelpphone.ca',
    description:
        'Kids Help Phone is a 24/7 e-mental health service offering free, confidential support to young people in English and French. Phone service is also offered in over 100 languages including Plains Cree, Severn Ojibwe, Ukrainian, Russian, Pashto, Dari, Mandarin and Arabic with the help of trained interpreters.'
  },
  {
    title: 'Naseeha Mental Health',
    phone: '1 (866) 627-3342',
    hours: '12 PM – 3 AM, 7 days a week',
    location: '',
    website: 'https://naseeha.org',
    description:
        'Naseeha Mental Health is confidential helpline, where youth can receive immediate, anonymous, and confidential support over the phone from 12 PM – 3 AM, 7 days a week. With a particular focus on Muslim youth/students.  '
  },
  {
    title: 'South Asian Canadians Health and Social Services (SACHSS)',
    phone: '',
    phoneNode: (
      <span>
        <a href="tel:+1-437-254-2794">+1-437-254-2794</a>, <a href="tel:+1-647-523-6380">+1-647-523-6380</a> or <a href="tel:+1-416-863-0511">+1-416-863-0511</a>
        <br />
      </span>
    ),
    hours: '24/7',
    location: '27 Tapscott Road, Unit 1',
    website: 'https://sachss.ca/',
    description:
        'SACHSS offers culturally and linguistically appropriate services for South Asian men, women, seniors, and youth, and other communities. SACHSS also offers a distress helpline in multiple languages (English, French, Hindi, Punjabi, Urdu, Tamil, Gujarati, Malayalam, Arabic).'
  }
];

const CommunityResourcesUTMStudent = [
  {
    title: 'Sexual Assault & Domestic Violence Care Centres',
    phone: '905 848 7493',
    hours: '24/7',
    location: 'Trillium Health Centre, 100 Queensway W, Mississauga',
    website: 'https://trilliumhealthpartners.ca/patientservices/womens/Pages/sexualassault.aspx',
    description:
      'Help individuals who have been sexually assaulted or have been victims of domestic violence within the Peel Region (Mississauga, Brampton and Caledon area).'
  },
  {
    title: 'Interim Place',
    phone: '905 676 8515',
    hours: '24/7',
    location: '',
    website: 'http://www.interimplace.com/',
    description:
      'Offers crisis line, online chat, and in-person counselling and support, referrals, information about sexual abuse and assault.'
  },
  {
    title: 'Distress Centre Halton',
    phone: '905 849 4541',
    hours: '24/7',
    location: '',
    website: '',
    description:
      'Confidential support and referrals provided by volunteers 24 hours a day.'
  },
  {
    title: 'Drug & Alcohol Helpline',
    phone: '1 866 531 2600',
    hours: '24/7',
    location: '',
    website: 'https://www.connexontario.ca/',
    description:
      'Provides confidential and free information about health services information for people experiencing problems with alcohol and drugs, mental illness and/or gambling.'
  },
  {
    title: "Assaulted Women's Helpline",
    phone: '416 863 0511',
    hours: '24/7',
    location: '',
    website: 'www.awhl.org/home',
    description:
      'Offers a 24-hour telephone and TTY crisis line to all woman who have experienced abuse.'
  },
  {
    title: 'Distress Centres of Greater Toronto',
    phone: '416 408 4357',
    hours: '24/7',
    location: '',
    website: 'www.torontodistresscentre.com',
    description:
      'Offer anonymous and confidential distress and emotional support lines in 8 languages. Interpreters for callers in crisis are available in 151 languages. TTY service available for the hearing impaired.'
  },
  {
    title: 'LGBT Youthline',
    phone: '',
    phoneNode: (
      <span>
        Text <a href="tel:647 694 4275">647-694-4275</a> or Chat Sun – Fri 4PM – 9:30 PM EST
      </span>
    ),
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'www.youthline.ca',
    description:
      'Confidential, non-judgmental & informed LGBTTQQ2SI peer support that affirms and supports the experiences of youth (29 and under) across Ontario via chat and text services.'
  },
  {
    title: 'Gerstein Centre Mental Health Crisis Line',
    phone: '416-929-5200; TTY 416-929-9647',
    hours: '24/7',
    location:
      'Phone: Various, Ontario; Crisis Response Team: South Central Toronto',
    website: 'gersteincentre.org',
    description:
      'Provides mental health crisis support, strategies for addressing immediate problems, and connections to ' +
      'services offering ongoing support.'
  },
  {
    title: 'Peel Crisis Services & COAST',
    phone: '905 278 9036',
    hours: '24/7',
    location: '',
    website: 'https://www.ontario.ca/locations/health/locationDetails.php?location=29426534&lang=en',
    description:
      'Offer crisis intervention services (phone and outreach) to people with mental illness who are in crisis.'
  }
];

const EmergencyResources = [
  {
    title: '911',
    phone: '911',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'crtc.gc.ca/eng/phone/911',
    description:
      'For immediate danger and life-threatening emergencies or incidents occurring in the moment where you need police, ' +
      'fire, or ambulance services.'
  },
  {
    title: 'Campus Safety',
    phone: ['416-978-2222 (Urgent)', '416-978-2323 (Non-urgent)'],
    hours: '24/7',
    location: '21 Sussex Ave',
    website: 'https://www.campussafety.utoronto.ca/',
    description:
        'Report assault or immediate danger of assault, fighting, suspicious persons or trespassers, sexual assault, theft in progress, collision/disabled vehicle, etc. For immediate danger, call 911, then Campus Safety.'
  },
  {
    title: '988 Suicide Crisis Helpline ',
    phone: '988',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'https://988.ca/',
    description:
        'If you are dealing with thoughts of suicide, or if you are worried about someone else, 9-8-8 is here for you. When you reach out, a trained responder will listen without judgement, provide support and understanding, and can tell you about resources that will help.'
  }

];

const EmergencyResourcesUTSC = [
  {
    title: '911',
    phone: '911',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'crtc.gc.ca/eng/phone/911',
    description:
      'For immediate danger and life-threatening emergencies or incidents occurring in the moment where you need police, fire, or ambulance services.' 
  },
  {
    title: 'Campus Safety',
    phone: '416 978 2222',
    hours: '24/7',
    location: 'SW-304, 1265 Military Trail',
    website: 'utsc.utoronto.ca/safety',
    description:
      'Provides 24/7 service and protection to the UTSC community. Officers patrol the campus on foot, on bicycles and in vehicles. If you are concerned about an immediate threat to your safety or property, or that of others, call 911 or Campus Community Police at (416) 978-2222, or use one of the emergency Code Blue telephones located on campus.'
  },
  {
    title: '988 Suicide Crisis Helpline ',
    phone: '988',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'https://988.ca/',
    description:
        'If you are dealing with thoughts of suicide, or if you are worried about someone else, 9-8-8 is here for you. When you reach out, a trained responder will listen without judgement, provide support and understanding, and can tell you about resources that will help.'
  }

];

const EmergencyResourcesUTM = [
  {
    title: '911',
    phone: '911',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'crtc.gc.ca/eng/phone/911',
    description:
      'For immediate danger and life-threatening emergencies or incidents occurring in the moment where you need police, ' +
      'fire, or ambulance services.'
  },
  {
    title: 'Campus Safety',
    phone: '',
    phoneNode: (
      <span>
        <a href="tel:905 828 5200">905-828-5200</a> (general inquiries)
        <br />
        <a href="tel:905 569 4333">905-569-4333</a> (emergencies)
        <br />
      </span>
    ),
    hours: '24/7',
    location: 'DV 3116',
    website: 'www.utm.utoronto.ca/safety',
    description:
      'Dedicated to creating and maintaining a safe and secure environment for students, staff, faculty and visitors.'
  },
  {
    title: '988 Suicide Crisis Helpline ',
    phone: '988',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'https://988.ca/',
    description:
        'If you are dealing with thoughts of suicide, or if you are worried about someone else, 9-8-8 is here for you. When you reach out, a trained responder will listen without judgement, provide support and understanding, and can tell you about resources that will help.'
  }

];

const StudentResourcesStaff = [
  {
    title: 'Health & Wellness',
    phone: '416-978-8030',
    hours: 'Business Hours',
    location: '700 Bay Street, 3rd, 12th, and 14th floors',
    website: 'https://studentlife.utoronto.ca/department/health-wellness/',
    description:
      'Range of health services for physical and mental health, wellness programs, and information.'
  },
  {
    title: 'Health & Wellness - Mental Health Services & Supports',
    phone: '416-978-8030, option 5',
    hours: 'Business Hours',
    location: '700 Bay Street, 12th Floor',
    website: ['https://studentlife.utoronto.ca/task/find-easy-access-to-mental-health-support/', 'https://studentlife.utoronto.ca/service/mental-health-clinical-services/' ],
    description:
      'Range of mental health clinical services to suit student needs.'
  },
  {
    title: 'Health & Wellness Peer Support Service',
    phone: '',
    hours: '',
    location: '',
    website: 'https://studentlife.utoronto.ca/service/peer-support/',
    description:
      'Chat with trained UofT peers in 1:1, drop-in, confidential spaces online or in-person.'
  },
  {
    title: 'Centre for Learning Strategy Support',
    phone: '',
    hours: 'Business Hours',
    location: '800 Bay Street, 5th Floor',
    website: 'https://learningstrategy.utoronto.ca',
    description:
        'Help with identifying and achieving learning goals along with access to tailored learning supports.'
  },
  {
    title: 'Accessibility Services',
    phone: '416-978-8060',
    hours: 'Business Hours',
    location: '455 Spadina Ave.,4th Floor, Suite 400',
    website: 'https://studentlife.utoronto.ca/department/accessibility-services/',
    description:
      'Provides services and support for learning, problem solving and inclusion and assistance with navigating disability-related barriers to academic success.'
  },
  {
    title: 'Centre for International Experiences',
    phone: '416 978 2564',
    hours: 'Business Hours',
    location: '33 St. George Street',
    website: 'www.studentlife.utoronto.ca/cie',
    description:
      'Range of programs and services to support international students, as well as global learning opportunities for all students. '
  },
   {
    title: 'First Nations House Indigenous Student Services',
    phone: '416-978-8227',
    hours: 'Business Hours',
    location: 'Borden Building North, 563 Spadina Avenue, 3rd Floor',
    website: 'https://studentlife.utoronto.ca/department/first-nations-house/',
    description:
      'Provides culturally relevant services to Indigenous students in support of academic success, personal growth and leadership development.'
  },
  {
    title: 'Housing',
    phone: '416-978-8045',
    hours: 'Business Hours',
    location: '214 College St., Room 150',
    website: 'www.studentlife.utoronto.ca/hs',
    description:
      'Housing Services offers the information, resources and support you need to meet your housing goals.'
  },
  {
    title: 'U of T Telus Health Student Support',
    phoneNode: (
      <span>
        <a href="tel:1 844 451 9700">1-844-451-9700</a>
        <br />
        Outside of North America: <a href="tel:001-416-380-6578">001-416-380-6578</a>
        <br />
      </span>
    ),
    hours: '24/7',
    location: '',
    website: 'https://studentlife.utoronto.ca/service/myssp/',
    description:
          'Real-time and/or appointment-based, multi-lingual, confidential, 24-hour support for any school, health, or general life concern at no cost to students'
  }
];

const StudentResourcesStaffUTSC = [
  {
    title: 'Health & Wellness Centre',
    phone: '416 287 7065',
    hours: 'Business Hours',
    location: 'SL-270, 1265 Military Trail',
    website: 'www.utsc.utoronto.ca/hwc',
    description:
      'Offers convenient and confidential health care, counselling and health promotion services for all registered students at UTSC.'
  },
  {
    title: 'AccessAbility Services',
    phone: '416 287 7560',
    hours: 'Business Hours',
    location: 'Arts & Administration Building, AA142, 1265 Military Trail',
    website: 'www.utsc.utoronto.ca/ability',
    description:
      'Provides services and academic accommodations to students who have a documented learning, physical, sensory, mental health disability or medical condition.'
  },
  {
    title: 'Academic Advising & Career Centre',
    phone: '416 287 7561',
    hours: 'Business Hours',
    location: 'AC-213, 1265 Military Trail',
    website: 'www.utsc.utoronto.ca/aacc',
    description:
      'The Centre integrates developmental advising, learning skills, career counselling and employment coaching through individual appointments, workshops, experiential programming, events and a range of online resources.'
  },

  {
    title: 'Good2Talk Student Helpline',
    phone: '1 866 925 5454',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'good2talk.ca',
    description:
      'Professional counselling, information and referrals helpline for mental health, addictions and students ' +
      'well-being.'
  },
  {
    title: 'First Nations House (Indigenous Student Services)',
    phone: ['416 978 8227', '1 800 810 8069'],
    hours: 'Business Hours',
    location: '563 Spadina Avenue, 3rd Floor',
    website: 'https://studentlife.utoronto.ca/department/first-nations-house/',
    description:
      'First Nations House provides culturally relevant services to Indigenous students in support ' +
      'of academic success, personal growth and leadership development.'
  },
  {
    title: 'Indigenous Outreach Program',
    phone: '',
    hours: '',
    location: '',
    website: 'www.utsc.utoronto.ca/studentlife/indigenous-outreach-program-overview',
    description:
      'Provides students a place to connect with the Indigenous Community on traditional teaching land.'
  },

  {
    title: 'Student Life',
    phone: '416-208-5129',
    hours: 'Business Hours',
    location: 'SL-157, 1265 Military Trail',
    website: 'www.utsc.utoronto.ca/studentlife',
    description:
      'Offers exciting programs, cultivates strong communities and provides opportunities that enhance the student experience outside of the classroom.'
  },

  {
    title: 'International Student Centre',
    phone: '416 287 7087',
    hours: 'Business Hours',
    location: 'Highland Hall, HL448',
    website: 'www.uoft.me/utscinternational',
    description:
      'Provides International students with support and guidance including the University Health Insurance Plan.'
  },
  {
    title: 'Multi-Faith Engagement',
    phone: 'cep@utsc.utoronto.ca',
    hours: 'Business Hours',
    location: '',
    website: 'www.utsc.utoronto.ca/studentlife/multi-faith-engagement',
    description:
      'Services and programs to foster practice, observance, interfaith community, support and learning to students.'
  },
  {
    title: 'Student Housing and Residence Life',
    phone: '416 287 7365',
    hours: 'Business Hours',
    location: 'Residence Centre, 1265 Military Trail',
    website: 'www.utsc.utoronto.ca/residences',
    description:
      'Fosters a safe, fun, and inclusive community that supports your academic achievement and personal development.'
  },
  {
    title: 'U of T Telus Health Student Support',
    phoneNode: (
      <span>
        <a href="tel:1 844 451 9700">1-844-451-9700</a>
        <br />
        Outside of North America: <a href="tel:001-416-380-6578">001-416-380-6578</a>
        <br />
      </span>
    ),
    hours: '24/7',
    location: 'Canada and International',
    website: 'uoft.me/THSS',
    description:
      'Real-time and/or appointment-based, multi-lingual, confidential, 24-hour support for any school, health, or general life concern at no cost to students.'
  }
];

const StudentResourcesStaffUTM = [
  {
    title: 'Accessibility Services',
    phone: '905 569 4699',
    hours: 'Business Hours',
    location: 'Student Services Hub, Davis Building',
    website: 'www.utm.utoronto.ca/accessibility',
    description:
      'Provides academic accommodations and services to students who have a disability, mental health condition, acquired brain injury, ADHD, autism spectrum disorder or chronic health condition. Students who have temporary disabilities are also eligible to receive services.'
  },
  {
    title: 'Robert Gillespie Academic Skills Centre',
    phone: '905 828 3858',
    hours: 'Business Hours',
    location: 'NE 3251',
    website: 'www.utm.utoronto.ca/asc ',
    description:
      'Offers a range of workshops, seminars, facilitated study groups, and individual consultations to help identify and develop academic skills needed for success in your studies.'
  },
  {
    title: 'Health & Counselling Centre',
    phone: '905 828 5255',
    hours: 'Business Hours',
    location: 'DV 1152',
    website: 'www.utm.utoronto.ca/health',
    description:
      'HCC provides medical services, physical and mental health services and peer to peer health education through an interdisciplinary team of health professionals. The HCC also has a dedicated student wellness space, the Wellness Den, that features daily, drop-in wellness activities to support learning and success. Drop by the Student Services Hub (DV 2207) to build your wellness routine'
  },
  {
    title: 'Indigenous Centre',
    phone: '905 569 4867',
    hours: 'Business Hours',
    location: 'DV 3206',
    website: 'www.utm.utoronto.ca/indigenous-centre',
    description:
      'The Centre supports Indigenous students, staff, and faculty and also offers opportunities for non-Indigenous peoples to better understand Indigenous peoples, cultures, stories, and ceremonies through programs.'
  },
  {
    title: 'International Education Centre',
    phone: '905 569 4716',
    hours: 'Business Hours',
    location: 'Student Services Hub, Davis Building',
    website: 'www.utm.utoronto.ca/international',
    description: 'IEC offers international opportunities for academic credit and as co-curricular experiences. IEC also assists international students on immigration-related matters, UHIP and transition to University while offering programs to connect.'
  },
  {
    title: 'Student Housing & Residence Life',
    phone: '905 828 5286',
    hours: 'Business Hours',
    location: 'Oscar Peterson Hall (OPH), Room 120',
    website: 'www.utm.utoronto.ca/housing',
    description:
      'Student Housing provides a diverse range of housing options, helps students with off-campus services and offers information and resources.'
  },
  {
    title: 'WalkSafer Program',
    phone: '905 828 5200',
    hours: '24/7',
    location: '',
    website:
      'https://www.utm.utoronto.ca/campus-police/safety-programs/work-alone-walksafe-programs',
    description:
      'WalkSafer escorts will come to your location to walk you to your destination, including waiting with you at a bus stop.'
  },
  {
    title: 'Good2Talk Student Helpline',
    phone: '1 866 925 5454',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'good2talk.ca',
    description:
      'Professional counselling, information and referrals helpline for mental health, addictions and students ' +
      'well-being.'
  },
  {
    title: 'U of T Telus Health Student Support',
    phoneNode: (
      <span>
        <a href="tel:1 844 451 9700">1-844-451-9700</a>
        <br />
        Outside of North America: <a href="tel:001-416-380-6578">001-416-380-6578</a>
        <br />
      </span>
    ),
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'https://www.utm.utoronto.ca/international/myssp',
    description:
      'Immediate and/or ongoing confidential, 24-hour support for any school, health, or general life concern at no cost to students. Ongoing support is available in over 146 languages.'
  },
  {
    title: 'Career Centre',
    phone: '905 828 5451',
    hours: 'Business Hours',
    location: 'Student Services Hub, Davis Building',
    website: 'www.utm.utoronto.ca/careers',
    description:
      'Offer individual appointments, workshops, programs, employment services, events, drop-in services and resources to support you in your career journey. '
  },
  {
    title: 'Centre for Student Engagement',
    phone: '905-828-3962',
    hours: 'Business Hours',
    location: 'CSE Connect Corner, DV 2077',
    website: 'uoft.me/utmengage',
    description: 'CSE offers campus & community-based co-curricular initiatives, club support, and programs to facilitate orientation & transition, and opportunities for student involvement and community engaged learning.'
  },
  {
    title: 'Office of the Registrar',
    phone: '905 828 5399',
    hours: 'Business Hours',
    location: 'KN 1235',
    website: 'www.utm.utoronto.ca/registrar',
    description:
      'Specialize in recruitment and admissions and transfer credit assessments, registration, enrolment, academic and financial advising, financial aid services, scheduling, exams, records management, and graduation.'
  },
];

const CampusAll = [
  {
    title: 'NAVI',
    phone: '',
    hours: '',
    location: '',
    website: 'https://prod.virtualagent.utoronto.ca/',
    description:
          'Chat-based virtual assistant for students wanting to learn more about the mental health supports available to them at the University of Toronto. All you have to do is click on the chat button and tell Navi what you need help with or how you are feeling.'
  },
  {
    title: 'Anti-Racism & Cultural Diversity Office',
    phone: '416-978-1259',
    hours: 'Business Hours',
    location: '155 College Street, Suite 356',
    website: 'www.antiracism.utoronto.ca',
    description:
        'Provides support to students, staff and faculty through education programming, complaint resolution support, strategic initiatives and community outreach and engagement.'
  },
  {
    title: 'Campus Safety',
    phone: ['416-978-2222 (Urgent)', '416-978-2323 (Non-urgent)'],
    hours: '24/7',
    location: '21 Sussex Ave',
    website: 'https://www.campussafety.utoronto.ca/',
    description:
        'Creating safe, secure and equitable environment for students, staff ,faculty and visitors.'
  },
  {
    title: 'Community Safety Office',
    phone: '416-978-1485',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, 2nd Floor',
    website: 'www.communitysafety.utoronto.ca',
    description:
      'Equity office and tri-campus service that offers short-term support and assistance to students, staff, and faculty members of the University of Toronto community ' +
      'who have experienced personal safety concerns.'
  },
  {
    title: 'Family Care Office',
    phone: '416-978-0951',
    hours: 'Business Hours',
    location: '215 Huron Street, Suite 603',
    website: 'https://familycare.utoronto.ca/',
    description:
      'Provides confidential guidance, resources, referrals, educational programming and advocacy for the University of Toronto students, staff, faculty, post-doctoral fellows and their families.'
  },
  {
    title: 'Multi-Faith Centre',
    phone: '416-946-3120',
    hours: 'Business Hours',
    location: '569 Spadina Avenue',
    website: 'https://studentlife.utoronto.ca/department/multi-faith-centre-for-spiritual-study-practice/',
    description:
      'Supports the spiritual well-being of students, staff and faculty and increases understanding of and respect for religious beliefs and practices.'
  },
  {
    title: 'Sexual & Gender Diversity Office',
    phone: '416 946 5624',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, Suites 416-417',
    website: 'sgdo.utoronto.ca',
    description:
      'Tri-campus service that provides innovative education, programming, resources and advocacy on sexual and gender diversity for students, faculty, librarians, and staff.'
  },
  {
    title: 'Sexual Violence Prevention & Support Centre',
    phone: '416-978-2266',
    hours: 'Business Hours',
    location: 'Gerstein Science Information Centre (Gerstein Library), Suite B139',
    website: 'https://www.svpscentre.utoronto.ca/',
    description:
        'Serves students, staff, and faculty at the University of Toronto who are affected by sexual violence or harassment.'
  },
  {
    title: 'TravelSafer',
    phone: '416-978-7233',
    hours: '24/7',
    location: '',
    website: 'https://www.campussafety.utoronto.ca/travel-safer',
    description:
        'Free service offered by the University of Toronto Campus Safety that is available 24/7 365 days a year. A Building Patroller or Special Constable will escort you to and from any location on campus and abutting TTC stations for added peace of mind.'
  }
  /*{
    title: 'Anti-Racism & Cultural Diversity Office',
    phone: '416 978 1259',
    hours: 'Business Hours',
    location: '155 College Street, Suite 356',
    website: 'www.antiracism.utoronto.ca',
    description:
      'Provides assistance and managing confidential concerns and complaints of discrimination and/or harassment based on race, ancestry, place of origin, colour, ethnic origin, citizenship and/or creed.'
  },
  {
    title: 'Campus Police',
    phone: '416 978 2222',
    hours: '24/7',
    location: '21 Sussex Ave., Suite 100',
    website: 'campuspolice.utoronto.ca',
    description:
      'Provides programs on personal safety, protection of property, conflict resolution, maintenance of public order, community service and referral, crime prevention and detection.'
  },
  {
    title: 'Community Safety Office',
    phone: '416 978 1485',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, 2nd Floor',
    website: 'www.communitysafety.utoronto.ca',
    description:
      'Responds to students, staff, and faculty members of the University of Toronto community ' +
      'who have personal safety concerns.'
  },
  {
    title: 'Multi-Faith Centre',
    phone: '416 946 3120',
    hours: 'Business Hours',
    location: '569 Spadina Avenue',
    website: 'www.studentlife.utoronto.ca/mf',
    description:
      'Supports the spiritual well-being of students, staff and faculty and increases our understanding of and respect for religious beliefs and practices.'
  },
  {
    title: 'Sexual & Gender Diversity Office',
    phone: '416 946 5624',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, Suites 416-417',
    website: 'sgdo.utoronto.ca',
    description:
      'Develops partnerships to build supportive learning and working communities at the University ' +
      'of Toronto by working towards equity and challenging discrimination.'
  },
  {
    title: 'Sexual Violence Prevention & Support Centre',
    phone: '416 978 2266',
    hours: 'Business Hours',
    location: 'Gerstein Science Information Centre (Gerstein Library), Suite B139',
    website: 'www.thesvpcentre.utoronto.ca',
    description:
      'The Centre facilitates access to support, services and accommodations for students, staff and faculty members who have been affected by sexual violence or sexual harassment.'
  }
*/
];

const CampusAllUTSC = [
  {
    title: 'NAVI',
    phone: '',
    hours: '',
    location: '',
    website: 'https://prod.virtualagent.utoronto.ca/',
    description:
          'Chat-based virtual assistant for students wanting to learn more about the mental health supports available to them at the University of Toronto. All you have to do is click on the chat button and tell Navi what you need help with or how you are feeling.'
  },
  {
    title: 'Sexual & Gender Diversity Office',
    phone: '416 946 5624',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, Suites 416-417',
    website: 'sgdo.utoronto.ca',
    description:
      'Develops partnerships to build supportive learning and working communities at the University ' +
      'of Toronto by working towards equity and challenging discrimination.'
  },
  {
    title: 'Anti-Racism & Cultural Diversity Office',
    phone: '416 978 1259',
    hours: 'Business Hours',
    location: '155 College Street, Suite 356',
    website: 'www.antiracism.utoronto.ca',
    description:
      'Provides assistance and managing confidential concerns and complaints of discrimination and/or harassment based ' +
      'on race, ancestry, place of origin, colour, ethnic origin, citizenship and/or creed.'
  },
  {
    title: 'Sexual Violence Prevention & Support Centre',
    phone: '416 978 2266',
    hours: 'Business Hours',
    location: 'EV141 Environmental Science & Chemistry Building',
    website: 'www.thesvpcentre.utoronto.ca',
    description:
      'The Centre facilitates access to support, services and accommodations for students, staff and faculty members who have been affected by sexual violence or sexual harassment.'
  },

  {
    title: 'Lone Worker',
    phone: '416 287 7398',
    hours: '24/7',
    location: 'Various, UTSC Campus',
    website: 'www.utsc.utoronto.ca/police/lone-worker',
    description:
      'If you are working or studying alone after regular business hours or in isolated areas, Campus Community Police will provide you with a personal safety radio for direct contact should a personal safety emergency arise.'
  },

  {
    title: 'Community Safety Office',
    phone: '416 978 1485',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, 2nd Floor',
    website: 'www.communitysafety.utoronto.ca',
    description:
      'Responds to students, staff, and faculty members of the University of Toronto community ' +
      'who have personal safety concerns.'
  },

  {
    title: 'Travel Safer',
    phone: '416 287 7022',
    hours: '24/7',
    location: 'Various, UTSC Campus',
    website: 'utsc.utoronto.ca/police/travel-safer',
    description:
      'If you feel uncertain when you need to travel to your vehicle, residence, or another building, and would feel more comfortable having someone travel with you.'
  },
  {
    title: 'Campus Safety',
    phone: '416-978-2222',
    hours: 'Business Hours',
    location: 'Science Wing, Room SW 304, 1265 Military Trail',
    website: 'utsc.utoronto.ca/police',
    description:
      'Provides 24/7 service and protection to the UTSC community. If you are concerned about an immediate threat to your safety or property, or that of others, call 911 or Campus Safety at (416) 978-2222, or use one of the emergency Code Blue telephones located on campus.'
  }
];

const CampusAllUTM = [
  {
    title: 'NAVI',
    phone: '',
    hours: '',
    location: '',
    website: 'https://prod.virtualagent.utoronto.ca/',
    description:
          'Chat-based virtual assistant for students wanting to learn more about the mental health supports available to them at the University of Toronto. All you have to do is click on the chat button and tell Navi what you need help with or how you are feeling.'
  },
  {
    title: 'UTM Campus Safety',
    phone: '',
    phoneNode: (
      <span>
        <a href="tel:905 828 5200">905-828-5200</a> (general inquiries)
        <br />
        <a href="tel:905 569 4333">905-569-4333</a> (emergencies)
        <br />
      </span>
    ),
    hours: '24/7',
    location: 'DV 3116',
    website: 'www.utm.utoronto.ca/campus-police',
    description:
      'Dedicated to creating and maintaining a safe and secure environment for students, staff, faculty and visitors.'
  },
  {
    title: 'Community Safety Office',
    phone: '416 978 1485',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, 2nd Floor',
    website: 'www.communitysafety.utoronto.ca',
    description:
      'Responds to students, staff, and faculty members of the University of Toronto community ' +
      'who have personal safety concerns.'
  },
  {
    title: 'Equity & Diversity Office',
    phone: '905 569 4916',
    hours: 'Business Hours',
    location: 'DV 3094G',
    website: 'www.utm.utoronto.ca/equity-diversity',
    description:
      'Work with students, staff, faculty, and librarians to make UTM more welcoming and inclusive. Organize events and community building activities and provide education and training. Provide confidential complaint support and resolution assistance for human rights related discrimination and/or harassment.'
  },
  {
    title: 'Anti-Racism & Cultural Diversity Office',
    phone: '416 978 1259',
    hours: 'Business Hours',
    location: '155 College Street, Suite 356',
    website: 'www.antiracism.utoronto.ca',
    description:
      'Provides assistance and managing confidential concerns and complaints of discrimination and/or harassment based ' +
      'on race, ancestry, place of origin, colour, ethnic origin, citizenship and/or creed.'
  },
  {
    title: 'Multi-Faith Centre',
    phone: '',
    hours: '',
    location: '',
    website: 'www.utm.utoronto.ca/utm-engage/student-groups/multi-faith',
    description:
      'Provides opportunities to celebrate your spiritual and faith-based practices on campus by providing multi-faith spaces on campus and faith-based campus groups.'
  },
  {
    title: 'Sexual & Gender Diversity Office',
    phone: '416 946 5624',
    hours: 'Business Hours',
    location: '',
    website: 'https://sgdo.utoronto.ca/',
    description:
      'Develops partnerships to build supportive learning and working communities at the University ' +
      'of Toronto by working towards equity and challenging discrimination.'
  },
  {
    title: 'Sexual Violence Prevention & Support Centre',
    phone: '416 978 2266',
    hours: 'Business Hours',
    location: 'DV 3094G and DV3093F',
    website: 'www.svpscentre.utoronto.ca',
    description:
      'Provide confidential services for students, staff, and faculty affected by sexual violence and/or sexual harassment and also provides programming, training, education and consultation.'
  },
  {
    title: 'UTM Positive Space Committee',
    phone: '',
    hours: '',
    location: '',
    website: 'www.positivespace.utoronto.ca/mississauga',
    description:
      'Welcomes participation from LGBTQ+ students, staff and faculty and allies to create more inclusive spaces for LGBTQ+ members of the University community.'
  },
  {
    title: 'Recreation Athletics and Wellness Centre (RAWC)',
    phone: '',
    phoneNode: (
      <span>
        <a href="tel:905-828-3714">905-828-3714</a> (Recreation Athletics Wellness Centre RAWC)
        <br />
      </span>
    ),
    hours: 'Business Hours',
    location: '',
    website: 'www.utm.utoronto.ca/athletics',
    description:
      'State-of-the-art facility where you can participate in a variety of fitness, recreation, and sports programs. Learn a new sport, try a fitness class, or dive into pool activities!'
  } 
];

const AppResources = [
  {
    title: 'UofT Campus Safety App',
    phone: '',
    hours: '',
    location: '',
    website: 'https://www.campussafety.utoronto.ca/u-of-t-safety-app',
    description:
        'Personal safety app available for free download at Google Play and the Apple Store. Access Live chat with Campus Safety, TravelSafer, mobile Bluelight, Friend Walk and Support Services.'
  },
  {
    title: 'UofT Telus Health Student Support App',
    phone: '1-844-451-9700',
    hours: '24/7',
    location: 'Canada and International',
    website: 'https://uoft.me/THSS',
    description:
        'Real-time and/or appointment-based, multi-lingual, confidential, 24-hour support for any school, health, or general life concern at no cost to students.'
  }
];

const AppResourcesUTSC = [
  {
    title: 'UTSC Student Experience app (UTSC)',
    phone: '',
    hours: '',
    location:
      'Search "UTSC Student Experience" on the App Store or Google Play',
    website: 'uoft.me/utscapp',
    description:
      'A convenient way to access student services on the go and connect with campus events.'
  },
  {
    title: 'UofT Telus Health Student Support App',
    phone: '',
    hours: '',
    location: '',
    website: 'https://uoft.me/THSS',
    description: '',
    descriptionNode: <div>Search Telus Health Student Support on Apple App Store or Google Play Store and download the app. Complete your profile so you can browse health and wellness resources on the go, start a live chat or call with a counsellor – anytime, anywhere!</div>,
  }
];

const AppResourcesUTM = [
  {
    title: 'UofT Telus Health Student Support App',
    phone: '',
    hours: '',
    location: '',
    website: 'https://myssp.app/ca/home ',
    description: '',
    descriptionNode: <div>Search Telus Health Student Support on Apple App Store or Google Play Store and download the app. Complete your profile so you can browse health and wellness resources on the go, start a live chat or call with a counsellor – anytime, anywhere!</div>,
  }
];

const StudentResourcesOther = [
  {
    title: 'Good2Talk Student Helpline',
    phone: '1 866 925 5454',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'good2talk.ca',
    description:
      'Professional counselling, information and referrals helpline for mental health, addictions and students ' +
      'well-being.'
  },
  {
    title: 'Sexual Assault & Domestic Violence Care Centres',
    phone: '',
    hours: '24/7',
    location: '',
    website: '',
    descriptionNode:
      (<div style={{wordBreak: 'break-word'}}>
        Scarborough Hospital Network's Emergency Departments{' '}
        <a href='https://www.shn.ca/sexual-assault/' target="_blank" rel="noopener noreferrer">
        https://www.shn.ca/sexual-assault/
        </a>
        <br/>
        Women's College Hospital, Mobile Locations 24/7 and Partner ED Locations{' '}
        <a href='www.womenscollegehospital.ca/care-programs/sexual-assault-domestic-violence-care-centre/' target="_blank" rel="noopener noreferrer">
          https://www.womenscollegehospital.ca/care-programs/sexual-assault-domestic-violence-care-centre/
        </a>
      </div>)
  },
  {
    title: 'Toronto Rape Crisis Centre/Multicultural Women Against Rape ',
    phone: '416 597 8808',
    hours: '24/7',
    website: 'trccmwar.ca',
    description:
      'A grassroots, women and non-binary run collective working towards a violence-free world by providing anti-oppressive, feminist peer support to survivors of sexual violence through support, education and activism.'
  },
  {
    title: 'Connex Ontario',
    phone: '',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'www.connexontario.ca/',
    description:
      'Provides confidential and free information about health services information for people experiencing problems with alcohol and drugs, mental illness and/or gambling.'
  },
  {
    title: 'Anishnawbe Health Toronto Mental Health Crisis Line',
    phone: ['416 360 0486', '416 920 2605'],
    hours: '',
    location: '225 Queen St E or 179 Gerrard, St E',
    website: 'www.aht.ca',
    description:
      'Improves health & well-being with Anishnawbe Health Toronto traditional healers, Elders and medicine people, and other health professionals.'
  },
  {
    title: "Assaulted Women's Helpline",
    phone: '416 863 0511',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'www.awhl.org/home',
    description:
      'Offers a 24-hour telephone and TTY crisis line to all woman who have experienced abuse.'
  },
  {
    title: 'Distress Centres of Greater Toronto',
    phone: '416 408 4357',
    hours: '24/7',
    location: 'Various, Canada',
    website: 'www.torontodistresscentre.com',
    description:
      'Provides crisis, emotional support and suicide prevention + intervention + postvention services to individuals in our community.'
  },
  {
    title: 'LGBT Youth Line',
    phone: ['1 800 268 9688', '647 694 4275'],
    hours: '24/7',
    location: '',
    website: 'www.youthline.ca',
    description:
      'Confidential, non-judgmental & informed LGBTTQQ2SI peer support that affirms and supports the experiences of youth (29 and under) across Ontario via chat, text and email.'
  },
  {
    title: 'Gerstein Centre Mental Health Crisis Line',
    phone: '416 929 5200; TTY 416 929 9647',
    hours: '24/7',
    location: 'Phone: Various, Ontario; Crisis Response Team: South Central Toronto',
    website: 'gersteincentre.org',
    description:
      'Provides mental health crisis support, strategies for addressing immediate problems, and connections to services offering ongoing support.'
  },
  {
    title: 'Scarborough Health Network Community Crisis Program',
    phone: '416 495 2891',
    hours: '24/7',
    location: 'Various, Scarborough & East York',
    website: 'www.shn.ca/mental-health/crisis-support/',
    description:
      'Providing telephone crisis support, crisis de-escalation and support, safety and crisis planning, mental health assessment and referral, brief psychotherapies, and community visits.'
  },
  {
    title: 'Distress and Crisis Ontario',
    phone: '',
    hours: '',
    location: '',
    website: 'http://www.dcontario.org/',
    description:
      'Offer support and a variety of services to their communities where you can find a listening ear for lonely, depressed, and/or suicidal people, usually 24/7.'
  },
  {
    title: 'Kids Help Phone',
    phone: '1 800 668 6868',
    hours: '',
    location: '',
    website: 'kidshelpphone.ca/',
    description:
      '24/7, national support service.We offer professional counselling, information and referrals and volunteer-led, text-based support to young people in both English and French.'
  },
  {
    title: 'Canadian Mental Health Association',
    phone: '',
    hours: '',
    location: '',
    website: 'https://ontario.cmha.ca/',
    description:
      'Promote mental health in collaboration with others and further equitable access to mental health services and champion the reduction of mental health disparities.'
  },
  {
    title: 'Big White Wall',
    phone: '',
    hours: '',
    location: '',
    website: 'www.bigwhitewall.com/?lang=en-ca&from=ca/v2/Home.aspx?lang=en-ca',
    description:
      'Online peer support community for mental health, free for Ontario students.Can be accessed 24/7 from anywhere with trained practitioners available.'
  },
  {
    title: 'BounceBack',
    phone: '',
    hours: '',
    location: '',
    website: 'bouncebackontario.ca/',
    description:
      'Free skill-building program managed by the CMHA where they offer coaching programs through phone sessions and online videos with tips.'
  },
  {
    title: 'Wellness Together Canada',
    phone: '',
    hours: '',
    location: '',
    website: 'ca.portal.gs/',
    description:
      'Provides free online resources, tools, apps and connections to trained volunteers and qualified mental health professionals when needed.'
  }
];

const EmergencyResourcesOther = [
  {
    title: '911',
    phone: '911',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'crtc.gc.ca/eng/phone/911/',
    description:
      'For immediate danger and life-threatening emergencies or incidents occurring in the moment where you need police, fire, or ambulance services.'
  },
  {
    title: 'Campus Safety',
    phone: ['416-978-2222 (Urgent)', '416-978-2323 (Non-urgent)'],
    hours: '24/7',
    location: '21 Sussex Ave',
    website: 'https://www.campussafety.utoronto.ca/',
    description:
        'Report assault or immediate danger of assault, fighting, suspicious persons or trespassers, sexual assault, theft in progress, collision/disabled vehicle, etc.'
  },
  {
    title: '988 Suicide Crisis Helpline ',
    phone: '988',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'https://988.ca/',
    description:
        'If you are dealing with thoughts of suicide, or if you are worried about someone else, 9-8-8 is here for you. When you reach out, a trained responder will listen without judgement, provide support and understanding, and can tell you about resources that will help.'
  }
];

const Resources = {
  StudentResources,
  StudentResourcesUTSC,
  StudentResourcesUTM,
  StudentResourcesStaff,
  StudentResourcesStaffUTSC,
  StudentResourcesStaffUTM,
  StaffResources,
  StaffResourcesUTSC,
  StaffResourcesUTM,
  CommunityResources,
  CommunityResourcesUTSC,
  CommunityResourcesUTM,
  CommunityResourcesUTMStudent,
  EmergencyResources,
  EmergencyResourcesUTSC,
  EmergencyResourcesUTM,
  CampusAll,
  CampusAllUTSC,
  CampusAllUTM,
  AppResources,
  AppResourcesUTSC,
  AppResourcesUTM,
  StudentResourcesOther,
  EmergencyResourcesOther
};

export default Resources;



// WEBPACK FOOTER //
// ./src/containers/Resources/constant.jsx